import { firstBy } from "thenby";

if (window.developerPortal) {
    document.addEventListener("DOMContentLoaded", () => {
        function setLinksOnTable() {
            // data-href link on table row
            const trElements = document.querySelectorAll("tr[data-href]");

            trElements.forEach((el) => {
                el.addEventListener("click", (e) => {
                    e.preventDefault();

                    const url = el.getAttribute("data-href");
                    const paymentMethodName = el.querySelector(".product-name")?.textContent?.trim() || "";
                    const index = Array.from(el.parentElement.children).indexOf(el);

                    // Get the Vue instance
                    const vueInstance = document.querySelector("#paymentmethods").__vue__;

                    if (vueInstance && vueInstance.searchQuery && window.AdobeTracking) {
                        // Determine if it's country view
                        const isCountryView = vueInstance.showCountryOverview;
                        const resultsCount = isCountryView
                            ? vueInstance.filteredCountries.reduce(
                                  (total, country) => total + country.paymentProducts.length,
                                  0,
                              )
                            : vueInstance.selectedOptionsWithPaymentProductsLinkedToPaymentMethods.length;

                        window.AdobeTracking.trackSearchClickThrough({
                            searchKeyword: vueInstance.searchQuery,
                            searchResultIndex: index + 1,
                            clickedText: paymentMethodName,
                            clickedURL: url,
                            numberOfSearchResults: resultsCount,
                        });

                        // Navigate after a short delay to ensure tracking completes
                        setTimeout(() => {
                            window.location = url;
                        }, 200);
                    } else {
                        window.location = url;
                    }

                    return false;
                });
            });
        }

        if (!window.developerPortal.countries) {
            console.log("No countries supplied for plugin.");
        }
        if (!window.developerPortal.paymentProducts) {
            console.log("No payment products supplied for plugin.");
        }
        if (!window.developerPortal.paymentMethods) {
            console.log("No payment methods supplied for plugin.");
        }

        if (!Array.prototype.find) {
            Object.defineProperty(Array.prototype, "find", {
                value: function (predicate) {
                    if (this == null) {
                        throw new TypeError('"this" is null or not defined');
                    }

                    const o = Object(this);
                    const len = o.length >>> 0;
                    if (typeof predicate !== "function") {
                        throw new TypeError("predicate must be a function");
                    }

                    const thisArg = arguments[1];
                    let k = 0;
                    while (k < len) {
                        const kValue = o[k];
                        if (predicate.call(thisArg, kValue, k, o)) {
                            return kValue;
                        }
                        k++;
                    }

                    return undefined;
                },
            });
        }
        const _extends =
            Object.assign ||
            function (target) {
                for (let i = 1; i < arguments.length; i++) {
                    const source = arguments[i];
                    for (let key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            };
        const countries = window.developerPortal.countries;
        const paymentProducts = window.developerPortal.paymentProducts;
        const paymentMethods = window.developerPortal.paymentMethods;
        const amountOfPaymentProductsToDisplayBeforeShowMore = 9999;
        const loadMoreIncrement = 9999;

        function getPaymentMethodName(paymentMethodCode) {
            const matchingPaymentMethod = paymentMethods.find(function (element) {
                return element.code === paymentMethodCode;
            });
            if (matchingPaymentMethod) {
                return matchingPaymentMethod.name;
            }
        }

        function getPaymentProductInfo(paymentProduct) {
            const matchingPaymentProduct = paymentProducts.find(function (element) {
                return element.code === paymentProduct.code;
            });
            if (matchingPaymentProduct) {
                paymentProduct["paymentMethod"] = getPaymentMethodName(matchingPaymentProduct.paymentMethodCode);
                paymentProduct["name"] = matchingPaymentProduct.name;
                paymentProduct["logo"] = matchingPaymentProduct.logo;
                return true;
            }

            return false;
        }

        function getCountriesGroupValues(countries) {
            countries.forEach(function (country, index) {
                const emptyPaymentProducts = [];
                countries[index].paymentProducts.forEach(function (paymentProduct, paymentProductIndex) {
                    if (!getPaymentProductInfo(countries[index].paymentProducts[paymentProductIndex])) {
                        emptyPaymentProducts.push(paymentProductIndex);
                    }
                });

                // Remove payment products from country that have no data
                for (let i = 0; i < emptyPaymentProducts.length; i++) {
                    countries[index].paymentProducts.splice(emptyPaymentProducts[i], 1);
                }

                countries[index].relevance = index;
                countries[index].type = "country";
                countries[index].rowsVisible = amountOfPaymentProductsToDisplayBeforeShowMore;
                countries[index].prevalencePopoverVisible = false;
                countries[index].popoverVisible = false;

                countries[index].sortType = "prevalence";
                countries[index].sortOrderPrevalence = "desc";
                if (countries[index].paymentProducts) {
                    sortByProperty(countries[index].paymentProducts, "prevalence", -1, "name");
                }
            });

            return countries;
        }

        function getPaymentMethodGroupValues(paymentMethods) {
            paymentMethods.forEach(function (paymentMethod, index) {
                paymentMethods[index] = paymentMethod;
                paymentMethods[index].paymentMethodCode = paymentMethods[index].code;
                paymentMethods[index].code = "PM-" + paymentMethods[index].code;
                paymentMethods[index].initialOrder = index;
                paymentMethods[index].type = "payment-method";
            });

            return paymentMethods;
        }

        function getPaymentProductGroupValues(paymentMethods) {
            paymentMethods.forEach(function (paymentMethod, index) {
                paymentMethods[index] = paymentMethod;
                paymentMethods[index].initialOrder = index;
                paymentMethods[index].type = "payment-product";
            });

            return paymentMethods;
        }

        const options = [
            {
                groupLabel: window.developerPortal.translations.country,
                groupCode: "country",
                groupValues: getCountriesGroupValues(countries),
            },
            {
                groupLabel: window.developerPortal.translations.paymentMethod,
                groupCode: "payment-method",
                groupValues: getPaymentMethodGroupValues(paymentMethods),
            },
            {
                groupLabel: window.developerPortal.translations.paymentProduct,
                groupCode: "payment-product",
                groupValues: getPaymentProductGroupValues(paymentProducts),
            },
        ];

        function capitalize(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        const paymentMethodOptions = options.find(function (element) {
            return element.groupCode === "payment-method";
        });

        const paymentProductOptions = options.find(function (element) {
            return element.groupCode === "payment-product";
        });

        function sortByProperty(array, propertyName, reversed) {
            if (propertyName === "paymentMethodCode") {
                return array.sort(
                    firstBy(
                        function (v1, v2) {
                            let v1Name = "";
                            let v2Name = "";

                            paymentMethodOptions.groupValues.find(function (element) {
                                if (element.paymentMethodCode === v1.paymentMethodCode) {
                                    v1Name = element.name.toLowerCase();
                                }
                            });

                            paymentMethodOptions.groupValues.find(function (element) {
                                if (element.paymentMethodCode === v2.paymentMethodCode) {
                                    v2Name = element.name.toLowerCase();
                                }
                            });

                            if (v1Name < v2Name) {
                                return -1;
                            }
                            if (v1Name > v2Name) {
                                return 1;
                            }
                        },
                        { ignoreCase: true, direction: reversed },
                    ).thenBy(function (v1, v2) {
                        return v1.code.localeCompare(v2.code);
                    }),
                );
            }

            return array.sort(firstBy(propertyName, { ignoreCase: true, direction: reversed }));
        }

        paymentMethodOptions.groupValues = sortByProperty(paymentMethodOptions.groupValues, "initialOrder");
        paymentProductOptions.groupValues = sortByProperty(paymentProductOptions.groupValues, "name");

        let defaultOptions = [];

        function getQueryParameter(key) {
            key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, "\\$&"); // escape RegEx meta chars
            const match = location.search.match(new RegExp("[?&]" + key + "=([^&]+)(&|$)"));
            return match && decodeURIComponent(match[1].replace(/\+/g, " "));
        }

        let countryParameters = getQueryParameter("country");
        let paymentMethodParameters = getQueryParameter("payment-method");
        let paymentProductParameters = getQueryParameter("payment-product");

        // Set the default options based on URL parameters

        if (countryParameters) {
            countryParameters = countryParameters.split("|");

            const filterByCode = (item) => {
                //return jQuery.inArray(item.code, countryParameters) >= 0;
                return countryParameters.includes(item.code);
            };

            const combinedOptions = defaultOptions.concat(countryOptions.groupValues.filter(filterByCode));
            defaultOptions = removeDuplicates(combinedOptions, "name");
        }
        if (paymentMethodParameters) {
            paymentMethodParameters = paymentMethodParameters.split("|");

            const filterByCode = (item) => {
                //return jQuery.inArray(item.paymentMethodCode, paymentMethodParameters) >= 0;
                return paymentMethodParameters.includes(item.paymentMethodCode);
            };

            defaultOptions = defaultOptions.concat(paymentMethodOptions.groupValues.filter(filterByCode));
        }

        if (paymentProductParameters) {
            paymentProductParameters = paymentProductParameters.split("|");

            const filterByPaymentProductCode = (item) => {
                //return jQuery.inArray(item.code, paymentProductParameters) >= 0;
                return paymentProductParameters.includes(item.code);
            };

            defaultOptions = defaultOptions.concat(
                paymentProductOptions.groupValues.filter(filterByPaymentProductCode),
            );
        }

        function removeDuplicates(itemsArray, prop) {
            return itemsArray.filter(function (obj, pos, arr) {
                return (
                    arr
                        .map(function (mapObj) {
                            return mapObj[prop];
                        })
                        .indexOf(obj[prop]) === pos
                );
            });
        }

        function removeURLParameter(url, parameter) {
            const urlparts = url.split("?");
            if (urlparts.length >= 2) {
                const prefix = encodeURIComponent(parameter) + "=";
                const pars = urlparts[1].split(/[&;]/g);
                for (let i = pars.length; i-- > 0; ) {
                    if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                        pars.splice(i, 1);
                    }
                }
                url = urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "");
                return url;
            }

            return url;
        }

        function updateQueryString(key, value, url) {
            if (!url) {
                url = window.location.href;
            }
            const re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi");
            let hash;

            if (re.test(url)) {
                if (typeof value !== "undefined" && value !== null) {
                    return url.replace(re, "$1" + key + "=" + value + "$2$3");
                } else {
                    hash = url.split("#");
                    url = hash[0].replace(re, "$1$3").replace(/(&|\?)$/, "");
                    if (typeof hash[1] !== "undefined" && hash[1] !== null) {
                        url += "#" + hash[1];
                    }

                    return url;
                }
            }

            if (typeof value !== "undefined" && value !== null) {
                const separator = url.indexOf("?") !== -1 ? "&" : "?";
                hash = url.split("#");
                url = hash[0] + separator + key + "=" + value;
                if (typeof hash[1] !== "undefined" && hash[1] !== null) {
                    url += "#" + hash[1];
                }

                return url;
            }

            return url;
        }

        window.Vue.component("multiselect", window.VueMultiselect);
        window.Vue.config.devtools = true;

        new window.Vue({
            name: "paymentMethods",
            el: "#paymentmethods",
            computed: {
                filteredCountries: function () {
                    const that = this;
                    let combinedOptions = [];
                    const countryOptions = this.getCountryOptions();
                    const paymentProductOptions = this.getPaymentProductProductOptions();
                    const paymentProductsToDisplay = [];
                    let hasCountriesSelected = false;

                    if (this.selectedOptions.length > 0) {
                        // Populate list of payment products for filtering
                        for (let optionIndex = 0; optionIndex < this.selectedOptions.length; optionIndex++) {
                            const selectedOption = this.selectedOptions[optionIndex];
                            if (selectedOption && selectedOption.type === "payment-product") {
                                paymentProductsToDisplay.push(selectedOption.code);
                            }
                        }

                        for (let optionIndex = 0; optionIndex < this.selectedOptions.length; optionIndex++) {
                            const selectedOption = this.selectedOptions[optionIndex];
                            if (selectedOption) {
                                if (selectedOption.type === "continent") {
                                    for (let countryIndex = 0; countryIndex < countryOptions.length; countryIndex++) {
                                        const country = countryOptions[countryIndex];
                                        //if (jQuery.inArray(selectedOption.continentCode, country.continentCodes) >=
                                        // 0) {
                                        if (country.continentCodes.includes(selectedOption.continentCode)) {
                                            combinedOptions.push(country);
                                            hasCountriesSelected = true;
                                        }
                                    }
                                } else if (selectedOption.type === "country") {
                                    const selectedOptionCode = selectedOption.code;
                                    const selectedOptionCountry = countryOptions.find(function (element) {
                                        return element.code === selectedOptionCode;
                                    });
                                    combinedOptions.push(selectedOptionCountry);
                                    hasCountriesSelected = true;
                                }
                            }
                        }
                        for (let optionIndex = 0; optionIndex < this.selectedOptions.length; optionIndex++) {
                            const selectedOption = this.selectedOptions[optionIndex];
                            if (selectedOption) {
                                if (selectedOption.type === "payment-method") {
                                    for (let i = 0; i < paymentProductOptions.length; i++) {
                                        if (
                                            paymentProductOptions[i].paymentMethodCode ===
                                            selectedOption.paymentMethodCode
                                        ) {
                                            paymentProductsToDisplay.push(paymentProductOptions[i].code);
                                        }
                                    }
                                }
                                if (
                                    selectedOption.type === "payment-product" ||
                                    selectedOption.type === "payment-method"
                                ) {
                                    if (!hasCountriesSelected) {
                                        // Find in all countries
                                        for (
                                            let countryIndex = 0;
                                            countryIndex < countryOptions.length;
                                            countryIndex++
                                        ) {
                                            const country = countryOptions[countryIndex];
                                            let countryHasPaymentProduct = country.paymentProducts.find(
                                                function (element) {
                                                    //return jQuery.inArray(element.code, paymentProductsToDisplay) >= 0;
                                                    return paymentProductsToDisplay.includes(element.code);
                                                },
                                            );
                                            if (countryHasPaymentProduct) {
                                                combinedOptions.push(country);
                                            }
                                        }
                                    } else {
                                        let combinedOptionsIndex = combinedOptions.length;
                                        // Find in only the selected countries
                                        while (combinedOptionsIndex--) {
                                            const country = combinedOptions[combinedOptionsIndex];
                                            let removeCountry = true;
                                            for (
                                                let productsIndex = 0;
                                                productsIndex < country.paymentProducts.length;
                                                productsIndex++
                                            ) {
                                                //if (jQuery.inArray(country.paymentProducts[productsIndex].code,
                                                // paymentProductsToDisplay) >= 0) {
                                                if (
                                                    paymentProductsToDisplay.includes(
                                                        country.paymentProducts[productsIndex].code,
                                                    )
                                                ) {
                                                    removeCountry = false;
                                                    break;
                                                } else {
                                                    removeCountry = true;
                                                }
                                            }
                                            if (removeCountry) {
                                                combinedOptions.splice(combinedOptionsIndex, 1);
                                            }
                                        }
                                    }
                                }
                                if (paymentProductsToDisplay.length > 0) {
                                    for (let productIndex = 0; productIndex < combinedOptions.length; productIndex++) {
                                        const selectedOptionCountryToDisplay = countryOptions.find((element) => {
                                            return element.code === combinedOptions[productIndex].code;
                                        });

                                        // Remove individual payment products that are not available on the chosen
                                        // platform
                                        combinedOptions[productIndex] = _extends({}, selectedOptionCountryToDisplay, {
                                            paymentProducts: selectedOptionCountryToDisplay.paymentProducts.filter(
                                                function (product) {
                                                    //return jQuery.inArray(product.code, paymentProductsToDisplay) >=
                                                    // 0;
                                                    return paymentProductsToDisplay.includes(product.code);
                                                },
                                            ),
                                        });
                                    }
                                }
                            }
                        }
                    } else {
                        // No selection has been made
                        combinedOptions = countryOptions;
                    }

                    //add payment product id to combined options
                    combinedOptions.forEach(function (option) {
                        option.paymentProducts.forEach(function (product) {
                            paymentProductOptions.find(function (element) {
                                if (element.code === product.code) {
                                    product.paymentId = element.paymentId;
                                }
                            });
                        });
                    });

                    combinedOptions = removeDuplicates(combinedOptions, "code");
                    combinedOptions = removeDuplicates(combinedOptions, "name");

                    if (that.filteredPlatform) {
                        // Remove all countries that have no platforms selected by the platform filter
                        combinedOptions = combinedOptions.filter(function (item) {
                            for (let i = 0; i < item.paymentProducts.length; i++) {
                                const platform = item.paymentProducts[i].paymentPlatforms.find(function (element) {
                                    return element.name === that.filteredPlatform;
                                });
                                if (platform !== undefined) {
                                    return true;
                                }
                            }
                        });

                        for (let i = 0; i < combinedOptions.length; i++) {
                            const selectedOptionCountry = countryOptions.find(function (element) {
                                return element.code === combinedOptions[i].code;
                            });

                            // Remove individual payment products that are not available on the chosen platform
                            combinedOptions[i] = _extends({}, selectedOptionCountry, {
                                paymentProducts: selectedOptionCountry.paymentProducts.filter(function (item) {
                                    let hasPlatform = false;
                                    for (let a = 0; a < item.paymentPlatforms.length; a++) {
                                        if (item.paymentPlatforms[a].name === that.filteredPlatform) {
                                            hasPlatform = true;
                                        }
                                    }

                                    if (hasPlatform && paymentProductsToDisplay.length > 0) {
                                        //return jQuery.inArray(item.code, paymentProductsToDisplay) >= 0;
                                        return paymentProductsToDisplay.includes(item.code);
                                    }

                                    return hasPlatform;
                                }),
                            });

                            // If a different payment platform is chosen filtering for prevalence has to be recalculated
                            if (combinedOptions[i].sortType === "prevalence" && that.filteredPlatform) {
                                combinedOptions[i].paymentProducts = sortByProperty(
                                    combinedOptions[i].paymentProducts,
                                    function (v1, v2) {
                                        const v1platform = v1.paymentPlatforms.find(function (element) {
                                            return element.name === that.filteredPlatform;
                                        });
                                        const v2platform = v2.paymentPlatforms.find(function (element) {
                                            return element.name === that.filteredPlatform;
                                        });
                                        if (v1platform && v2platform) {
                                            return v1platform.prevalence - v2platform.prevalence;
                                        }
                                    },
                                    combinedOptions[i].sortOrderPrevalence === "asc" ? undefined : -1,
                                );
                            }
                        }
                    }

                    return combinedOptions;
                },
                totalCountriesCount: function () {
                    const countryOptions = this.options.find((element) => element.groupCode === "country");
                    if (countryOptions.groupValues) {
                        return countryOptions.groupValues.length;
                    }
                },
                selectedOptionsWithPaymentProductsLinkedToPaymentMethods: function () {
                    let combinedOptions = [];
                    const that = this;
                    const paymentProductOptions = this.options.find(
                        (element) => element.groupCode === "payment-product",
                    );

                    const removeDuplicates = (myArr, prop) =>
                        myArr.filter(function (obj, pos, arr) {
                            return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
                        });

                    if (this.selectedOptions.length > 0) {
                        for (let optionIndex = 0; optionIndex < this.selectedOptions.length; optionIndex++) {
                            const selectedOption = this.selectedOptions[optionIndex];
                            if (selectedOption.type === "payment-method") {
                                for (
                                    let countryIndex = 0;
                                    countryIndex < paymentProductOptions.groupValues.length;
                                    countryIndex++
                                ) {
                                    const country = paymentProductOptions.groupValues[countryIndex];
                                    if (selectedOption.paymentMethodCode === country.paymentMethodCode) {
                                        combinedOptions.push(country);
                                    }
                                }
                            } else {
                                combinedOptions.push(selectedOption);
                            }
                        }
                    } else {
                        combinedOptions = paymentProductOptions.groupValues;
                    }

                    combinedOptions = removeDuplicates(combinedOptions, "name");

                    if (this.sortType) {
                        if (this["sortOrder" + capitalize(this.sortType)] === "desc") {
                            combinedOptions = sortByProperty(
                                combinedOptions,
                                this.sortType === "paymentMethod" ? "paymentMethodCode" : this.sortType,
                                -1,
                            );
                        } else {
                            combinedOptions = sortByProperty(
                                combinedOptions,
                                this.sortType === "paymentMethod" ? "paymentMethodCode" : this.sortType,
                            );
                        }
                    } else {
                        combinedOptions = sortByProperty(combinedOptions, "paymentMethodCode", false);
                    }

                    if (this.filteredPlatform) {
                        // Remove all payment products that do not match the platform filter
                        combinedOptions = combinedOptions.filter(function (item) {
                            let hasPlatform = false;
                            if (item.paymentPlatforms && item.paymentPlatforms.length > 0) {
                                for (let i = 0; i < item.paymentPlatforms.length; i++) {
                                    if (item.paymentPlatforms[i] === that.filteredPlatform) {
                                        hasPlatform = true;
                                    }
                                }
                            }

                            return hasPlatform;
                        });
                    }

                    this.lastSortedOn = this.sortType;

                    // remove countries from methods
                    combinedOptions = combinedOptions.filter((option) => option.type !== "country");

                    return combinedOptions;
                },

                totalPaymentProductCount: function () {
                    const paymentProductOptions = this.options.find(function (element) {
                        return element.groupCode === "payment-product";
                    });
                    if (paymentProductOptions.groupValues) {
                        return paymentProductOptions.groupValues.length;
                    }
                },
            },
            methods: {
                getNamedPrevalence: function (name, data) {
                    let prevalence = "";
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].name === name) {
                            prevalence = data[i].prevalence;
                        }
                    }
                    return (parseInt(prevalence) || 0) * 20;
                },
                searchChange: function (searchQuery) {
                    this.searchQuery = searchQuery;
                    let matchingCountries = countries.filter(
                        (item) => item.name.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1,
                    );

                    if (matchingCountries && searchQuery) {
                        this.matchingCountries = matchingCountries;
                    } else {
                        this.matchingCountries = undefined;
                    }
                },
                updateResults: function (value) {
                    this.showCountryOverview = value.some((entry) => entry.type === "country");

                    if (window.AdobeTracking && this.searchQuery) {
                        window.AdobeTracking.trackInternalSearchCompleted({
                            searchKeyword: this.searchQuery,
                            numberOfSearchResults: value.length,
                            interactionIdentifier: "payment methods",
                        });
                    }
                },
                clearAll: function () {
                    if (history.replaceState) {
                        history.replaceState(null, null, location.href.split("?")[0]);
                    }
                    this.filteredPlatform = "";
                    this.itemsVisible = loadMoreIncrement;
                    this.selectedOptions = [];
                    this.urlParametersCountry = "";
                    this.urlParametersPaymentMethod = "";
                    this.urlParametersPaymentProduct = "";
                },
                getPaymentMethodNameByCode: function (code) {
                    const paymentMethodOptions = this.options.find(function (element) {
                        return element.groupCode === "payment-method";
                    });
                    const paymentMethod = paymentMethodOptions.groupValues.find(function (paymentMethod) {
                        return paymentMethod.paymentMethodCode === code;
                    });

                    if (paymentMethod) {
                        return paymentMethod.name ? paymentMethod.name : "";
                    }
                },
                setPrevalencePopover: function (option) {
                    const countryOptions = this.getCountryOptions();
                    for (let i = 0; i < countryOptions.length; i++) {
                        if (countryOptions[i].code === option.code) {
                            countryOptions[i].prevalencePopoverVisible = !countryOptions[i].prevalencePopoverVisible;
                        }
                    }
                }, // setPopover: function (option) {
                //     const countryOptions = this.getCountryOptions();
                //     for (let i = 0; i < countryOptions.length; i++) {
                //         if (countryOptions[i].code === option.code) {
                //             countryOptions[i].popoverVisible = !countryOptions[i].popoverVisible;
                //         }
                //     }
                // },
                getCountryOptions: function () {
                    return this.options.find((element) => element.groupCode === "country").groupValues;
                },
                getPaymentProductProductOptions: function () {
                    return this.options.find((element) => element.groupCode === "payment-product").groupValues;
                },
                sortPaymentProductsCountries: function (option, type) {
                    let countryOptions = this.getCountryOptions();
                    for (let i = 0; i < countryOptions.length; i++) {
                        if (countryOptions[i].code === option.code) {
                            countryOptions[i].sortType = type;
                            if (this.lastSortedOn === type && option["sortOrder" + capitalize(type)] === "asc") {
                                countryOptions[i].paymentProducts = sortByProperty(
                                    countryOptions[i].paymentProducts,
                                    type,
                                    -1,
                                );
                                countryOptions[i]["sortOrder" + capitalize(type)] = "desc";
                            } else {
                                countryOptions[i].paymentProducts = sortByProperty(
                                    countryOptions[i].paymentProducts,
                                    type,
                                );
                                countryOptions[i]["sortOrder" + capitalize(type)] = "asc";
                            }
                        }
                    }
                    this.lastSortedOn = type;
                },
                sortPaymentProducts: function (type) {
                    this.sortType = type;

                    if (this.lastSortedOn === this.sortType && this["sortOrder" + capitalize(type)] === "asc") {
                        this["sortOrder" + capitalize(type)] = "desc";
                    } else {
                        this["sortOrder" + capitalize(type)] = "asc";
                    }
                },
                sortCountries: function (type, name) {
                    this.countriesSortOrderType = type;
                    this.countriesSortOrderName = name;
                },
                setPopover: function () {
                    this.platformPopoverVisible = !this.platformPopoverVisible;
                },
                suggestionGetsFocus: function (index) {
                    if (index === 0) {
                        jQuery(".multiselect__content-wrapper").addClass("always-open");
                        jQuery(".first-gets-focus").first().focus();
                    }
                },
                suggestionGetsBlur: function (event) {
                    if (!jQuery(event.relatedTarget).hasClass("first-gets-focus")) {
                        jQuery(".multiselect__content-wrapper").removeClass("always-open");
                    }
                },
                closeDropdown: function () {
                    const that = this;
                    setTimeout(function () {
                        if (that.$emit().$children[0].isOpen) {
                            that.$emit().$children[0].toggle();
                        }
                    });
                },
                trackPaymentMethodClick: function (paymentProduct, index, isCountryView) {
                    if (window.AdobeTracking && this.searchQuery) {
                        const resultsCount = isCountryView
                            ? this.filteredCountries.reduce(
                                  (total, country) => total + country.paymentProducts.length,
                                  0,
                              )
                            : this.selectedOptionsWithPaymentProductsLinkedToPaymentMethods.length;

                        window.AdobeTracking.trackSearchClickThrough({
                            searchKeyword: this.searchQuery,
                            searchResultIndex: index + 1,
                            clickedText: paymentProduct.name,
                            clickedURL:
                                "/${appLocale}/payment-methods-and-features/payment-methods/" + paymentProduct.code,
                            numberOfSearchResults: resultsCount,
                        });
                    }
                },
            },
            data: function () {
                return {
                    itemsVisible: loadMoreIncrement,
                    amountOfPaymentProductsToDisplayBeforeShowMore: amountOfPaymentProductsToDisplayBeforeShowMore,
                    selectedOptions: defaultOptions,
                    options: options,
                    matchingCountries: [],
                    sortType: "name",
                    sortOrderName: "asc",
                    sortOrderCountries: "",
                    sortOrderPaymentMethod: "",
                    sortOrderPaymentPlatforms: "",
                    filteredPlatform: getQueryParameter("platform") ? getQueryParameter("platform") : "",
                    platformPopoverVisible: false,
                    showCountryOverview: false,
                    selectedTags: [],
                    searchQuery: "",
                };
            },
            mounted() {
                setLinksOnTable();
            },
            updated() {
                setLinksOnTable();
            },
        });
    });
}
